import { Alt1GLVertexArray } from "../../../lib/alt1/alt1gl/overlay/Alt1GLVertexArray";
import { lazy } from "../../../lib/Lazy";
export class Mesh {
    constructor(vertices, indices) {
        this.vertices = vertices;
        this.indices = indices;
        this._vertexArray = lazy(() => new Alt1GLVertexArray(this));
    }
    vertexArray() { return this._vertexArray.get(); }
}
(function (Mesh) {
    let Vector3;
    (function (Vector3) {
        function add(...a) {
            return {
                x: a.map(v => v.x).reduce((c, d) => c + d, 0),
                y: a.map(v => v.y).reduce((c, d) => c + d, 0),
                z: a.map(v => v.z).reduce((c, d) => c + d, 0),
            };
        }
        Vector3.add = add;
        function scale(factor, vector) {
            return {
                x: vector.x * factor,
                y: vector.y * factor,
                z: vector.z * factor,
            };
        }
        Vector3.scale = scale;
        function toString(vector) {
            return `(${vector.x}, ${vector.y}, ${vector.z})`;
        }
        Vector3.toString = toString;
    })(Vector3 = Mesh.Vector3 || (Mesh.Vector3 = {}));
})(Mesh || (Mesh = {}));
